var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.228,
    height: 262.459,
    viewBox: "0 0 140.228 262.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.136,
    y1: -0.197,
    x2: 3.108,
    y2: 1.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(757.969 375.594)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-757.969 -375.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-667.984-115.759a8.66,8.66,0,0,1-2.623-6.374V-315.6l-56.617,43.493a8.469,8.469,0,0,1-5.623,1.874,8.245,8.245,0,0,1-7.124-3.748l-16.122-21a8.95,8.95,0,0,1-1.875-5.249,8.969,8.969,0,0,1,4.124-7.5l83.987-65.241a17.108,17.108,0,0,1,9.373-2.625h33.745a8.707,8.707,0,0,1,6.374,2.625,8.7,8.7,0,0,1,2.625,6.374v244.462a8.68,8.68,0,0,1-2.625,6.374,8.678,8.678,0,0,1-6.374,2.625h-34.87A8.663,8.663,0,0,1-667.984-115.759Z",
    transform: "translate(757.969 375.594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7255bf6bde85a9f291b99542515d72dd.svg";
export { ForwardRef as ReactComponent };